module.exports = __webpack_public_path__ + "static/media/small_circle_bg.a183089d.svg";